// Admin helper functions

export const escapeHtml = (unsafe) => {
  if (!unsafe) return "";
  return String(unsafe)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

export const convertStarsToHtml = (text) => {
  if (!text) return "";
  const escaped = escapeHtml(text);
  const replaced = escaped.replace(/\*(.+?)\*/g, (m, p1) => `<strong>${p1}</strong>`);
  return replaced.replace(/\r?\n/g, "<br />");
};

export const htmlToPlainText = (html) => {
  if (!html) return "";
  try {
    const div = document.createElement("div");
    const sanitized = String(html).replace(/<br\s*\/?>/gi, "\n");
    div.innerHTML = sanitized;
    return div.textContent || div.innerText || "";
  } catch (e) {
    return String(html).replace(/<[^>]*>/g, "").replace(/\r?\n/g, "\n");
  }
};

export const htmlToEditorText = (html) => {
  if (!html) return "";
  try {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = String(html);
    const decoded = textarea.value;
    const container = document.createElement("div");
    container.innerHTML = decoded.replace(/<br\s*\/?>(?=>)?/gi, "\n");

    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) return node.nodeValue || "";
      if (node.nodeType === Node.ELEMENT_NODE) {
        const tag = node.tagName.toLowerCase();
        if (tag === "br") return "\n";
        if (tag === "strong" || tag === "b") {
          const inner = Array.from(node.childNodes).map(walk).join("");
          return `*${inner}*`;
        }
        return Array.from(node.childNodes).map(walk).join("");
      }
      return "";
    };

    const result = walk(container);
    return result.replace(/\r?\n[ \t\r\n]+/g, "\n").trim();
  } catch (e) {
    return String(html)
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/<\s*(strong|b)[^>]*>(.*?)<\s*\/\s*\1>/gi, "*$2*")
      .replace(/<br\s*\/?>(?=>)?/gi, "\n")
      .replace(/<[^>]*>/g, "")
      .replace(/\r?\n[ \t\r\n]+/g, "\n").trim();
  }
};

export const formatAdminArticleDate = (item) => {
  if (!item) return "";
  if (item.publishedDate) return new Date(item.publishedDate).toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' });
  if (item.date) {
    const parts = String(item.date).split('/');
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts.map(p => parseInt(p,10));
      if (!isNaN(dd) && !isNaN(mm) && !isNaN(yyyy)) {
        return new Date(yyyy, mm-1, dd).toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' });
      }
    }
    return item.date;
  }
  return new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const categoryOptions = [
  { value: "worldnews", label: "World News" },
  { value: "sportsnews", label: "Sports News" },
  { value: "localnews", label: "Local News" },
  { value: "business", label: "Business" },
  { value: "entertainment", label: "Entertainment" },
  { value: "technology", label: "Technology" },
  { value: "india", label: "India" },
  { value: "gujarat", label: "Gujarat" },
  { value: "e-paper", label: "E-Paper" },
  { value: "other", label: "Other" },
];
